import * as React from 'react';
import { render } from 'react-dom';
import { HashRouter as ReactRouter } from 'react-router-dom';
import { Routes } from './router/Routes';
import { EmotionCache } from './EmotionCache';
import { SettingsConfigProvider } from './SettingsProvider/SettingsConfigProvider';
import {
	VersionInfoProvider,
	VersionInfoData,
} from './SettingsProvider/VersionInfoContext';

export interface RenderAppOptions {
	versionInfo?: VersionInfoData;
}

export async function renderApp(versionInfo?: VersionInfoData): Promise<void> {
	// Platform is already initialized by the bridge at this point
	// No need to call initialize again
	render(
		<EmotionCache>
			<ReactRouter>
				<VersionInfoProvider versionInfo={versionInfo}>
					<SettingsConfigProvider>
						<Routes />
					</SettingsConfigProvider>
				</VersionInfoProvider>
			</ReactRouter>
		</EmotionCache>,
		document.getElementById('app')
	);
}
